import { getLocale } from "../runtime";

const da_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi beklager ulejligheden. Der er opstået en uventet fejl.`
};

const en_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `We apologize for the inconvenience. An unexpected error has occurred.`
};

const es_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Disculpamos las molestias. Ha ocurrido un error inesperado.`
};

const fi_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Pahoittelemme häiriötä. Odottamaton virhe on tapahtunut.`
};

const nb_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi beklager ulempen. Det har oppstått en uventet feil.`
};

const sv_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi ber om ursäkt för besväret. Ett oväntat fel har inträffat.`
};

const errorsubtitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_errorsubtitle(inputs)
	if (locale === "en") return en_errorsubtitle(inputs)
	if (locale === "es") return es_errorsubtitle(inputs)
	if (locale === "fi") return fi_errorsubtitle(inputs)
	if (locale === "nb") return nb_errorsubtitle(inputs)
	if (locale === "sv") return sv_errorsubtitle(inputs)
	return "errorSubtitle";
};

export { errorsubtitle as "errorSubtitle" };